import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RRule } from 'rrule';
import { PromotionModel } from 'src/app/models/promotion-model';
import { environment } from 'src/environments/environment';
import { ShareLinkDialogComponent } from '../dialogs/share-link-dialog/share-link-dialog.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ResponsiveBaseComponent } from '../responsive-base/responsive-base.component';

@Component({
    selector: 'app-promotion',
    templateUrl: './promotion.component.html',
    styleUrls: ['./promotion.component.scss'],
    standalone: false
})
export class PromotionComponent extends ResponsiveBaseComponent implements OnInit {
  @Input()
  public promotion: PromotionModel;

  @Output()
  public onDeletePressed = new EventEmitter();

  @Output()
  public onActivatePressed = new EventEmitter();

  @Output()
  public onDeactivatePressed = new EventEmitter();

  @Output()
  public onEditPressed = new EventEmitter();

  public recurrenceDisplayString: string;

  constructor(private readonly shareLinkDialog: MatDialog,
    responsive: BreakpointObserver,
  ) {
    super(responsive);
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.promotion?.recurrencePattern) {
      this.recurrenceDisplayString = new RRule(RRule.parseString(this.promotion.recurrencePattern)).toText();
    }
    else {
      this.recurrenceDisplayString = 'Does not repeat';
    }
  }

  public delete(): void {
    this.onDeletePressed.emit(null);
  }

  public canShowActivateAction(): boolean {
    const result = this.promotion?.isInactive();
    return result;
  }

  public canShowReactivateAction(): boolean {
    const result = this.promotion?.isExpired() || this.promotion?.isArchived();
    return result;
  }

  public canShowArchiveAction(): boolean {
    const result = this.promotion?.isActive() || this.promotion?.isPendingActivation();
    return result;
  }

  public canShowEditAction(): boolean {
    const result = this.promotion?.isActive() || this.promotion?.isPendingActivation();
    return result;
  }

  public canShowShareAction(): boolean {
    const result = this.promotion?.isActive();
    return result;
  }

  public activate(): void {
    this.onActivatePressed.emit(null);
  }

  public deactivate(): void {
    this.onDeactivatePressed.emit(null);
  }

  public edit(): void {
    this.onEditPressed.emit(null);
  }

  public share(): void {
    this.shareLinkDialog.open(ShareLinkDialogComponent, {
      data: {
        title: "Share This",
        message: "Share this promotion on your social media",
        data: this.getPromotionLink()
      }
    });
  }

  public getPromotionLink() : string {
    return environment.storefrontUrl + "/promotions/" + this.promotion.id;
  }
}
